import React from 'react'
import { Controller, useFormContext } from 'react-hook-form'
import WeekDaySelector, { WeekDaySelectorProps } from 'src/Elements/Selectors/WeekDaySelector'

interface Props extends Omit<WeekDaySelectorProps, 'onSelectDay' | 'days'> {
  name: string
}

const DaySelector: React.FC<Props> = ({ name, ...props }) => {
  const { control, setValue } = useFormContext()

  const onSelectDay = (dayName: string, selected: boolean): void => {
    control._getWatch(name)?.[dayName] !== undefined && setValue(name, { ...control._getWatch(name), [dayName]: selected }, { shouldDirty: true })
  }

  return (
    <Controller
      name={name}
      control={control}
      render={({ field }) => <WeekDaySelector {...field} {...props} days={control._getWatch(name)} onSelectDay={onSelectDay} />}
    />
  )
}

export default DaySelector
